import React from "react";
import { usePaymentCore } from "@/features/payment";
import {
  PaymentRedirectingPage,
  PaymentSuccessPage,
  PaymentErrorPage,
  PaymentCancelPage,
} from "@/features/payment/payment-providers/stripe";

export const PaymentRouter: React.FC = () => {
  const { currentStep } = usePaymentCore();

  // Render different pages based on current step
  switch (currentStep) {
    case "redirecting":
      return <PaymentRedirectingPage />;
    case "success":
      return <PaymentSuccessPage />;
    case "error":
      return <PaymentErrorPage />;
    case "cancel":
      return <PaymentCancelPage />;
    default:
      return <PaymentRedirectingPage />;
  }
};
